<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Title:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input id="input-small" v-model="form.title" size="sm" placeholder="Enter title"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Description:</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea id="input-small" v-model="form.description" size="sm" placeholder="Enter description"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Applicable On:</label>
          </b-col>
          <b-col sm="12">
            <select-with-search :options-data="options" track_by="key" display="value" :search_without_api="true" @selectedOption="((v) => form.structure.applicable_on = v)"></select-with-search>
          </b-col>
          <b-col sm="12" class="ml-0">
            <label>Amount per quantity:</label>
          </b-col>
          <b-col sm="12">
            <b-input-group prepend="₹" size="sm"><b-form-input id="input-small" v-model="form.structure.value" size="sm" :value="0" type="number" placeholder="Enter amount"></b-form-input></b-input-group>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Fulfillment modes:</label>
          </b-col>
          <b-col sm="12">
            <select-with-search :options-data="fulfillment_modes" track_by="key" display="value" :search_without_api="true" :multi_select="true" @selectedOption="((v) => form.fulfillment_modes = v)"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Excluded Platforms:</label>
          </b-col>
          <b-col sm="12">
            <select-with-search :options-data="aggregators" track_by="value" display="text" :search_without_api="true" :multi_select="true" @selectedOption="((v) => form.excluded_platforms = v)"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Active:</label>
            <b-form-checkbox switch v-model="form.active" :value="true" name="check-button" size="sm"></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveCharge" class="btn btn-success">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {AggregatorPath, ChargesPath} from "../../../../path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";

export default {
  name: "add",
  components: {SelectWithSearch},
  props : ['selected_charge'],
  data(){
    return {
      form : {
        structure : {
          applicable_on : null,
          value : 0
        },
        active :true,
        excluded_platforms : [],
        fulfillment_modes : []
      },
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      filters : [],
      options : [
        {key : 'item.quantity',value : 'Item Quantity'},
        {key : 'order.order_subtotal',value : 'Order Subtotal'},
        {key : 'item.price',value : 'Item Price'}
      ],
      aggregators : [],
      fulfillment_modes : [
        {key : 'delivery', value : 'Delivery'},
        {key : 'pickup', value : 'Pickup'},
      ]
    }
  },
  watch : {
    selected_charge: {
      deep : true,
      handler(v){
        console.log(v);
        this.form = v;
      }
    }
  },
  mounted() {
    if(this.selected_charge){
      this.form = this.selected_charge;
    }
    this.getAggregators();
  },
  methods : {
    async getAggregators(){
      try {
        let res = await axios.get(this.baseUrl + AggregatorPath.getAggregators);
        if(res.data.status){
          this.aggregators = res.data.data;
        }
      }catch (e){
        console.log(e);
      }
    },
    async saveCharge(){
      try {
        let res = await axios.post(this.baseUrl + ChargesPath.ALL,this.form);
        if(res.data.status == true)
        {
          this.$bvToast.toast('Successfully added', {
            title: `Charges added`,
            variant: 'success',
            solid: true
          });
          this.$bvModal.hide("bv-add-charges");
          this.$emit("update");
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>